<template>
  <div class="qr-card">
    <div ref="qrContainer" class="qr-container"></div>
    <div class="qr-actions">
      <n-upload
        :show-file-list="false"
        accept="image/*"
        @change="onLogoSelected"
      >
        <n-button size="small" tertiary>
          {{ logoUrl ? "Trocar logo" : "Adicionar logo" }}
        </n-button>
      </n-upload>
      <n-button v-if="logoUrl" size="small" tertiary @click="removeLogo">
        Remover logo
      </n-button>
      <n-button size="small" type="primary" @click="download('png')">
        Baixar PNG
      </n-button>
      <n-button size="small" @click="download('svg')">Baixar SVG</n-button>
    </div>
  </div>
</template>

<script>
import QRCodeStyling from "qr-code-styling";

export default {
  name: "QrCodeCard",
  props: {
    url: { type: String, required: true },
    fileName: { type: String, default: "campaign-qr" },
    size: { type: Number, default: 220 },
  },
  data() {
    return {
      qr: null,
      logoUrl: "",
    };
  },
  watch: {
    url() {
      this.render();
    },
  },
  mounted() {
    this.render();
  },
  methods: {
    buildOptions() {
      return {
        width: this.size,
        height: this.size,
        type: "svg",
        data: this.url,
        image: this.logoUrl || undefined,
        margin: 8,
        qrOptions: {
          // High error correction so a center logo doesn't break scanning
          errorCorrectionLevel: this.logoUrl ? "H" : "M",
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 4,
          imageSize: 0.35,
        },
        dotsOptions: { color: "#1c1127", type: "rounded" },
        backgroundOptions: { color: "#ffffff" },
        cornersSquareOptions: { color: "#1c1127", type: "extra-rounded" },
      };
    },
    render() {
      // Always recreate the instance: qr-code-styling's update() refreshes
      // the displayed SVG but keeps a cached internal canvas, so PNG
      // downloads after an update() would export the FIRST generated code.
      this.qr = new QRCodeStyling(this.buildOptions());
      this.$refs.qrContainer.innerHTML = "";
      this.qr.append(this.$refs.qrContainer);
    },
    onLogoSelected({ file }) {
      const rawFile = file.file;
      if (!rawFile) return;
      const reader = new FileReader();
      reader.onload = () => {
        this.logoUrl = reader.result;
        this.render();
      };
      reader.readAsDataURL(rawFile);
    },
    removeLogo() {
      this.logoUrl = "";
      this.render();
    },
    download(extension) {
      this.qr.download({ name: this.fileName, extension });
    },
  },
};
</script>

<style scoped>
.qr-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.qr-container {
  background-color: #ffffff;
  padding: 8px;
  border-radius: 8px;
  line-height: 0;
}

.qr-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
</style>
